import React from 'react';
import { i8n } from '../../../i8n';

export default
class MainScreen extends React.Component {
	render(){
		return (
			<div>
				<h2>Strona w budowie!</h2>
				<p>Nowa strona domowa jest nadal w budowie.</p>
				<button text="PL" onClick={() => i8n.setLang('pl')}>PL</button>
				<button text="EN" onClick={() => i8n.setLang('en')}>EN</button>
				<p>Język: {i8n.current_lang}</p>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/Screens/MainScreen/index.js